module.exports = __webpack_public_path__ + "img/received_call_icon.f9934494.svg";